import * as React from 'react';

import { Redo2Icon, Undo2Icon } from 'lucide-react';
import { useEditorRef, useEditorSelector } from 'platejs/react';

import { ToolbarEditorButton } from './toolbar-editor';

export function RedoToolbarButton(props: React.ComponentProps<typeof ToolbarEditorButton>) {
  const editor = useEditorRef();
  const disabled = useEditorSelector((editor) => editor.history.redos.length === 0, []);

  return (
    <ToolbarEditorButton
      {...props}
      disabled={disabled}
      onClick={() => editor.redo()}
      onMouseDown={(e) => e.preventDefault()}
      tooltip="Redo"
    >
      <Redo2Icon />
    </ToolbarEditorButton>
  );
}

export function UndoToolbarButton(props: React.ComponentProps<typeof ToolbarEditorButton>) {
  const editor = useEditorRef();
  const disabled = useEditorSelector((editor) => editor.history.undos.length === 0, []);

  return (
    <ToolbarEditorButton
      {...props}
      disabled={disabled}
      onClick={() => editor.undo()}
      onMouseDown={(e) => e.preventDefault()}
      tooltip="Undo"
    >
      <Undo2Icon />
    </ToolbarEditorButton>
  );
}
